export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    console.error('Failed to copy: ', err);
    return false;
  }
}

export function isScreenLockSupported() {
  return 'wakeLock' in navigator;
}

async function getScreenLock() {
  if (isScreenLockSupported()) {
    let screenLock: WakeLockSentinel | undefined;
    try {
      screenLock = await navigator.wakeLock.request('screen');
    } catch (err) {
      // Fuhgeddaboudit
    }
    return screenLock;
  } else {
    console.warn('Screen lock not supported');
  }
}

export async function setupAutoScreenLock() {
  const cb = async () => {
    if (!screenLock || screenLock.released) {
      screenLock = await getScreenLock();
      if (screenLock) {
        screenLock.addEventListener('release', cb);
      }
    }
  };

  let screenLock = await getScreenLock();

  if (screenLock) {
    screenLock.addEventListener('release', cb);
  }

  document.addEventListener('visibilitychange', cb);

  return {
    getScreenLock: () => screenLock,
    destroy: () => {
      if (screenLock) {
        screenLock.release();
      }

      document.removeEventListener('visibilitychange', cb);
    },
  };
}
